var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupportNewTalentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "help_2_",
    "data-name": "help (2)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.32,
    height: 42.32,
    viewBox: "0 0 42.32 42.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_36414",
    "data-name": "Path 36414",
    d: "M224.578,210.9a13.721,13.721,0,0,0-7.525-12.218,18.66,18.66,0,0,1-18.373,18.373,13.684,13.684,0,0,0,19.179,5.623l6.659,1.842-1.842-6.659a13.631,13.631,0,0,0,1.9-6.961Zm0,0",
    transform: "translate(-182.258 -182.258)",
    fill: "#3dfc36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_36415",
    "data-name": "Path 36415",
    d: "M32.319,16.159A16.159,16.159,0,1,0,2.241,24.373L.059,32.259l7.886-2.181A16.163,16.163,0,0,0,32.319,16.159ZM13.68,12.4H11.2a4.959,4.959,0,1,1,8.306,3.66L17.4,17.987V19.92H14.92V16.895l2.912-2.666a2.454,2.454,0,0,0,.807-1.83,2.48,2.48,0,0,0-4.959,0Zm1.24,10H17.4v2.48H14.92Zm0,0",
    fill: "#3dfc36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportNewTalentIcon);
export default __webpack_public_path__ + "static/media/Support New Talent_icon.a5a37875a88ebd84b3a1892050c3ca09.svg";
export { ForwardRef as ReactComponent };